
export const MCR_ENDPOINT_V0 = "/api/v0/los/callreport/"

export const QUARTER_START_DATE = {
    "q1": "01-01",
    "q2": "04-01",
    "q3": "07-01",
    "q4": "10-01"
}

export const QUARTER_END_DATE = {
    "q1": "03-31",
    "q2": "06-30",
    "q3": "09-30",
    "q4": "12-31"
}